import { Tabs } from "antd";
import React from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { NavWrap } from "../ShopForTyres";
import BasicInfo from "./BasicInfo";
const { TabPane } = Tabs;

const CustomerInfo = () => {
  const history = useHistory();
  const location = useLocation();
  return (
    <NavWrap>
      <div className="customers showTyresFilters customer-info">
        <div className="head">
          <h3>
            Customer{" "}
            <span className="ml2">
              Users .{" "}
              <span
                className="cursor"
                onClick={() => {
                  history.push("/admin/customers");
                }}
              >
                Customers List
              </span>
            </span>
          </h3>
        </div>
        <div className="tabs">
          <Tabs defaultActiveKey="1">
            <TabPane tab="Basic Info" key="1">
              <BasicInfo customer={location?.state?.customer} />
            </TabPane>
            {/* <TabPane tab="Shipment Address" key="2">
              <ShipmentAddress />
            </TabPane> */}
          </Tabs>
        </div>
      </div>
    </NavWrap>
  );
};

export default CustomerInfo;
